module.exports = __webpack_public_path__ + "static/media/Cart-Red.b1ec775a.svg";